import { displayError, localize, getCurrentLanguageId } from "./common";

export default class HttpClient {
    async fetch(input: RequestInfo, init?: RequestInit, onError?: (e: Response|string) => void): Promise<Response> {
        try {
            const response = await fetch(input, this.withLanguageHeader(init));
            if (!response || !response.ok) {
                if (onError) {
                    onError(response);
                    return response;
                }
                else {
                    displayError(localize('AjaxCallFailGeneralMessage'));
                    throw response.statusText;
                }
            }
            return response;
        }
        catch (e) {
            if (onError) {
                onError(e);
            }
            else {
                displayError(localize('AjaxCallFailGeneralMessage'));
                throw e;
            }
        }
    }

    // The language header must be merged into EVERY request, not only those without a custom init —
    // previously any call passing its own init lost the header, so the server ran with LanguageId=0
    // (breaking language-dependent lookups and inserts). Skipped when the page carries no language
    // (sending the literal string "undefined" is worse than no header).
    private withLanguageHeader(init?: RequestInit): RequestInit {
        const request = init ?? {};
        const languageId = getCurrentLanguageId();
        if (!languageId) {
            return request;
        }

        const headers = new Headers(request.headers ?? {});
        if (!headers.has('Current-Language-Id')) {
            headers.set('Current-Language-Id', languageId);
        }
        return { ...request, headers };
    }
}
